module.exports = __webpack_public_path__ + "img/Wing_feathers_MetalRoughness.2d1e854.jpg";